<template>
    <article>
        <h5>啟用狀態</h5>
        <div class="mb-5">
            <v-select
                hide-details
                outlined
                v-model="product_mode"
                :items="product_setting.items"
                dense
                @change="displayProduct(product_mode)"
            >
            </v-select>
            <div v-if="product_mode === 1">
                行銷圖卡顯示期間，商品價格都會被修改
            </div>
        </div>
        <!-- <div class="input-container">
            <section>
                <label>									
                    商品價格模式
                </label>
                <v-container
                    class="px-0"
                    fluid
                    style="padding:0;"
                >
                    <v-radio-group v-model="product_mode" row>

                        <v-radio
                            label= "OFF"
                            :value= "0"
                            :color="$vuetify.theme.themes['dark']['primary']"
                            @click="updateStatus('marketing_card','product_mode', Number(0))"
                        ></v-radio>

                        <v-radio
                            label= "ON"
                            :value= "1"
                            :color="$vuetify.theme.themes['dark']['primary']"
                            @click="updateStatus('marketing_card','product_mode', Number(1))"
                        ></v-radio>

                    </v-radio-group>
                    
                </v-container>
            </section>	
        </div> -->
        <h5
            v-if="product_mode === 1"
        >商品優惠價</h5>
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section class="d-flex flex-column">
                <label>									
                    字體大小
                </label>
                <v-select
                    hide-details
                    label="請選擇字體大小"
                    :items="['24px', '26px', '28px', '30px', '32px', '34px', '36px']"
                    solo
                    style="max-width:400px;"
                    v-model="discount_price_size"
                    @change="updateStatus('marketing_card','discount_price_size', discount_price_size)"
                >
                </v-select>
            </section>
        </div>
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section class="d-flex flex-column">
                <label>									
                    顏色
                </label>
                <!-- <input 
                    type="color"
                    name=""
                    v-model="discount_price_color"
                    @input="updateStatus('marketing_card','discount_price_color', discount_price_color)"
                    placeholder="NT$3990"
                > -->
                <!-- <v-color-picker
                    v-model="discount_price_color"
                    elevation="15"
                    @input="updateStatus('marketing_card','discount_price_color', discount_price_color)"
                ></v-color-picker> -->

                <v-text-field
                    @change="updateStatus( 'marketing_card','discount_price_color', discount_price_color)"
					v-model="discount_price_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','discount_price_color', discount_price_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="discount_price_color_menu"
                            :colorValue="discount_price_color"
                            @updateColorValue="discount_price_color = $event"
                            @updateColorMenu="discount_price_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','discount_price_color', discount_price_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
        </div>	
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section class="d-flex flex-column">
                <label>									
                    價格
                </label>
                <!-- <input 
                    type="text" 
                    name=""
                    v-model="discount_price"
                    placeholder="範例: NT$3990"
                    @input="updateStatus('marketing_card','discount_price', discount_price)"
                > -->
                <v-text-field
                    @change="updateStatus('marketing_card','discount_price', discount_price)"
                    hide-details class="ma-0 pa-0" solo
                    v-model="discount_price"
                    placeholder="範例: NT$3990"
                    @input="updateStatus('marketing_card','discount_price', discount_price)"
                >
                </v-text-field>	
            </section>
        </div>
        <h5
            v-if="product_mode === 1"
        >
            商品文字
        </h5>
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section
                class="d-flex flex-column"
            >
                <label>									
                    字體大小
                </label>
                <v-select
                    hide-details
                    label="請選擇字體大小"
                    :items="['14px', '16px', '18px', '20px', '22px', '24px', '36px']"
                    solo
                    v-model="product_text_size"
                    @change="updateStatus('marketing_card','product_text_size', product_text_size)"
                >
                </v-select>
            </section>
        </div>
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section class="d-flex flex-column">
                <label>									
                    顏色
                </label>
                <!-- <input 
                    type="color" 
                    name=""
                    v-model="product_text_color"
                    style="cursor:pointer"
                    @input="updateStatus('marketing_card','product_text_color', product_text_color)"
                > -->
                <!-- <v-color-picker
                    v-model="product_text_color"
                    elevation="15"
                    @input="updateStatus('marketing_card','product_text_color', product_text_color)"
                ></v-color-picker> -->
                <v-text-field
                    @change="updateStatus( 'marketing_card','product_text_color', product_text_color)"
					v-model="product_text_color" hide-details class="ma-0 pa-0" solo
                    @input="updateStatus( 'marketing_card','product_text_color', product_text_color)"
				>
                    <template v-slot:append>
                        <ColorPicker
                            :colorMenu="product_text_color_menu"
                            :colorValue="product_text_color"
                            @updateColorValue="product_text_color = $event"
                            @updateColorMenu="product_text_color_menu = $event"
                            @changeStatusColorValue="updateStatus( 'marketing_card','product_text_color', product_text_color)"
                        />
                    </template>    
                </v-text-field>
            </section>
        </div>
        <div
            v-if="product_mode === 1"
            class="mb-5"
        >
            <section class="d-flex flex-column">
                <label>									
                    文字
                </label>
                <!-- <input 
                    type="text" 
                    name=""
                    v-model.trim="product_text"
                    placeholder="範例: 精選好物優惠"
                    @input="updateStatus('marketing_card','product_text', product_text)"
                > -->
                <v-text-field
                    @change="updateStatus('marketing_card','product_text', product_text)"
                    hide-details class="ma-0 pa-0" solo
                    v-model.trim="product_text"
                    placeholder="範例: 精選好物優惠"
                    @input="updateStatus('marketing_card','product_text', product_text)"
                >
                </v-text-field>
            </section>
        </div>
    </article>
</template>

<script>

import { mapState, mapGetters } from 'vuex';
import ColorPicker from "@/components/Utils/ColorPicker.vue"


export default {
    props: {
        oldSettingData: Object,
        loadOldSettingData: Boolean,
        timeLineMode: String
    },
    name: "MarketingCardSettingProductInfo",
    components: {
            ColorPicker
        },
    data() {
        return{

            // 商品價格模式選擇
            product_mode: 0,
            
            // 商品優惠價格字體大小
            discount_price_size: "",

            // 商品優惠價格顏色
            discount_price_color: "#ff0f0f",

            // 商品優惠價格
            discount_price: "NT$",

            // 商品文字字體大小
            product_text_size: "",

            // 商品文字顏色
            product_text_color: "#ff0f0f",

            // 商品文字
            product_text: "",

            marketing_card_setting: null,

            load_old_setting_data: false,

            discount_price_color_menu: false,
            product_text_color_menu: false,

            parseKey: {
                "活動預熱" : 'warmUpCardSetting',
                "活動進行" : 'activityCardSetting',
                "活動結束" : 'endUpCardSetting'
            },

            product_setting: {
                items: [
                    {
                        text: '啟用',
                        value: 1,
                    },
                    {
                        text: '關閉',
                        value: 0,
                    }
                ]
            }
        }
    },
    mounted() {
    },
    created() {
        console.log('prodcut_info:',this.loadOldSettingData)
        console.log('product_info2:',this.oldSettingData)
        // console.log(this.loadOldSettingData);
        // console.log(typeof this.product_mode);
    },
    methods: {
        async updateStatus(state, key, value) {
            await this.changeStatus(state, key, value)
            await this.$emit('save-time-line-setting')
        },
        changeStatus: async function(param_name,field_name, new_value){
            // let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
            // tmp[field_name] = new_value
            // this.$store.commit(param_name, tmp)
            // console.log('after_commit', this.$store.getters[param_name])
            this.$nextTick(() => {
                let tmp = JSON.parse(JSON.stringify(this.$store.getters.marketing_card)) 
                tmp[field_name] = new_value
                console.log(field_name)
                console.log(new_value)
                this.$store.commit(param_name, tmp)
                console.log('after_commit', this.$store.getters[param_name])
            })
        },
        displayProduct(product_mode){
            this.updateStatus('marketing_card','product_mode', product_mode)
        }
    },
    watch: {
        marketing_card: {
            handler: function(newValue) {
                this.marketing_card_setting = newValue
            },
            deep: true
        },
        loadOldSettingData: {
            handler: function(newValue) {
                this.load_old_setting_data = newValue
            },
            immediate: true
        },
        load_old_setting_data: {
            handler: function(newValue) {
                if (newValue) {
                    // alert("1")
                    console.log(newValue);
                    console.log(this.oldSettingData);
                    console.log(this.timeLineMode);
                    let add_column = this.oldSettingData !== null ? JSON.parse(this.oldSettingData.add_column) : JSON.parse(this[this.parseKey[this.timeLineMode]]['add_column'])
                    console.log(add_column);
                    console.log(add_column['product_mode']);
                    

                    // if (add_column['product_mode'] !== 1) return
                    console.log(this.product_mode);
                    this.product_mode = Number(add_column['product_mode'])
                    this.discount_price_size = add_column['discount_price_size']
                    this.discount_price_color = add_column['discount_price_color']
                    this.discount_price = add_column['discount_price']
                    this.product_text_size = add_column['product_text_size']
                    this.product_text_color = add_column['product_text_color']
                    this.product_text = add_column['product_text']


                    this.marketing_card.product_mode = add_column['product_mode']
                    this.marketing_card.timer_off_text = add_column['timer_off_text']
                    this.marketing_card.timer_off_text_color = add_column['timer_off_text_color'],
                    this.marketing_card.discount_price_size = add_column['discount_price_size']
                    this.marketing_card.discount_price_color = add_column['discount_price_color']
                    this.marketing_card.discount_price = add_column['discount_price']
                    this.marketing_card.product_text_size = add_column['product_text_size']
                    this.marketing_card.product_text_color = add_column['product_text_color']
                    this.marketing_card.product_text = add_column['product_text']

                    this.marketing_card.add_column = JSON.stringify({
                        "product_mode": add_column['product_mode'],
                        "timer_off_text": add_column['timer_off_text'],
                        "timer_off_text_color": add_column['timer_off_text_color'],
                        "discount_price": add_column['discount_price'],
                        "discount_price_size": add_column['discount_price_size'],
                        "discount_price_color": add_column['discount_price_color'],
                        "product_text": add_column['product_text'],
                        "product_text_color": add_column['product_text_color'],
                        "product_text_size": add_column['product_text_size']
				    })

                }
            },
            immediate: true
        },
        timeLineMode: {
            handler: function(newValue) {
                if (newValue) {
                    // alert("2")
                    console.log(newValue);
                    console.log(this.oldSettingData);
                    console.log(this.timeLineMode);
                    console.log(this[this.parseKey[this.timeLineMode]]);
                    let add_column = this.oldSettingData !== null ? JSON.parse(this.oldSettingData.add_column) : JSON.parse(this[this.parseKey[this.timeLineMode]]['add_column'])
                    console.log(add_column)

                    // if (add_column['product_mode'] !== 1) return
                    console.log(this.product_mode);
                    this.product_mode = Number(add_column['product_mode'])
                    this.discount_price_size = add_column['discount_price_size']
                    this.discount_price_color = add_column['discount_price_color']
                    this.discount_price = add_column['discount_price']
                    this.product_text_size = add_column['product_text_size']
                    this.product_text_color = add_column['product_text_color']
                    this.product_text = add_column['product_text']
                    this.product_mode = Number(add_column['product_mode'])

                    console.log(this.product_mode);



                    this.marketing_card.product_mode = add_column['product_mode']
                    this.marketing_card.timer_off_text = add_column['timer_off_text']
                    this.marketing_card.timer_off_text_color = add_column['timer_off_text_color'],
                    this.marketing_card.discount_price_size = add_column['discount_price_size']
                    this.marketing_card.discount_price_color = add_column['discount_price_color']
                    this.marketing_card.discount_price = add_column['discount_price']
                    this.marketing_card.product_text_size = add_column['product_text_size']
                    this.marketing_card.product_text_color = add_column['product_text_color']
                    this.marketing_card.product_text = add_column['product_text']


                    this.marketing_card.add_column = JSON.stringify({
                        "product_mode": add_column['product_mode'],
                        "timer_off_text": add_column['timer_off_text'],
                        "timer_off_text_color": add_column['timer_off_text_color'],
                        "discount_price": add_column['discount_price'],
                        "discount_price_size": add_column['discount_price_size'],
                        "discount_price_color": add_column['discount_price_color'],
                        "product_text": add_column['product_text'],
                        "product_text_color": add_column['product_text_color'],
                        "product_text_size": add_column['product_text_size']
				    })

                }
            },
            // immediate: true
        }
    },
    computed: {
        ...mapState( ['marketing_card'] ),
        ...mapGetters(['warmUpCardSetting','activityCardSetting','endUpCardSetting'])
    }
}
</script>

<style scoped>
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }
    .preview-hint-container > h4{
        display: flex;
        align-items: center;
        margin-top: 0.5em;

    }
    .preview-hint-container > h4 > i {
        margin-right: 0.5em;
    }
    .preview-container, .setting-container {
        display: flex;
        flex-direction: column;
    }
    .setting-container {
        width: 100%;
        overflow: hidden;
    }
    .setting-main {
        overflow: scroll;
    }
    .setting-main > article{
        background-color: #FFFFFF;
        border-bottom:1px #CCC solid;
        padding: 1em;
        overflow: scroll;
    }
    .setting-main > article:last-child {
        border-bottom: none;
    }
    .setting-main > article > h4 {
        padding-bottom:1em;
        font-weight: 600;
        font-size: 1.4em;
    }
    .setting-main > article > h5 {
        padding-bottom:1em;
        font-weight:500;
        font-size: 1.1em;
        display: flex;
    }
    .setting-main > article > h5 > i {
        color: #409aff;
        margin-right: 0.5em;
    }

    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .basic-setting-title {	
        display: flex;
    }
    .basic-setting-title > span {
        display: flex;
        align-items: center;
        font-size: 0.7em;
        color: #409aff;
        margin-left: 0.5em;
    }
    .basic-setting-title > span > i{

        font-size: 18px;
        margin-right: 5px;

    }
    .basic-setting-title > span > a{

        font-weight: 200;
        outline: none;
        text-decoration: none;
        color: #409aff;

    }
    .basic-setting-title > span > a:hover {
        text-decoration: underline;
    }
    .input-container {
        display: flex;
        flex-direction: row;
        width: 100%;
        margin-bottom: 1em;
    }
    .input-container > section {
        display: flex;
        width: 100%;
        flex-direction: row;
        margin-right: 1em;
        align-items: center;
    }
    .basic-setting-container > .input-container > section {
        align-items: unset;
        flex-direction: column;
    }
    .basic-setting-container > .input-container > section > label {
        margin-bottom: 0.5em;
    }
    .input-container > section > label > i {
        margin-right: 0.3em;
        color: #409aff;
    }
    .input-container > section > label {
        min-width: 6em;
        display: flex;
        align-items: center;
        font-weight: 200;
        margin-right: 0.5em;
    }
    .input-container > section > input[type="text"] {
        padding: 10px 18px 10px 18px;
        border-radius: .4285rem;
        border-color: #2b3553;
        border: 1px solid #cad1d7;
        width: 100%;
        outline: none;
        transition: all .3s;
    }
    .input-container > section > input[type="text"]:hover, .input-container > section > input[type="text"]:focus{
        border-color: #409aff;
    }

    .input-container > section > .mx-datepicker {
        width: 100%;
    }

    .disable_margin {
        margin: 0px;
    }

    .label_active {
        color: #ea8181;
    }
</style>